import axios from "axios";

export default class UserService {
	async getUsers(){
		try {
			const res = await axios({
				method: 'get',
				url: 'dashboard/users',
				headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
			});
			return res.data;
		} catch (err) {
			return err
		}		  
	}
	async getUsersByStatus(status_id){

		console.log('getUsersByStatus , ' , status_id);
		try {
			const res = await axios({
				method: 'get',
				url: 'dashboard/users',
				headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				params: {
					'status_id' : status_id,
				}
			});
			return res.data;
		} catch (err) {
			return err
		}		  
	}

	

	async getStatuses(){
		try {
			const res = await axios({
				method: 'get',
				url: 'dashboard/statuses',
				headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
			});
			return res.data;
		} catch (err) {
			return err
		}		  
	}
	async getStatusesWithCountUsers(){
		try {
			const res = await axios({
				method: 'get',
				url: 'dashboard/statuses/users',
				headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
			});
			return res.data;
		} catch (err) {
			return err
		}		  
	}
	


	// getUsers() {
	// 	return axios.get('dashboard/users').then((resp) => {
	// 		return resp.data;
	// 	  }).catch((err)=>{
	// 		  console.log(err)
	// 	  });		  
    // }
	getStatuses() {
		return axios.get('dashboard/statuses').then((resp) => {
			return resp.data;
		  }).catch((err)=>{
			  console.log(err)
		  });		  
    }
	async addUser(user){
		try {
			const res = await axios({
				method: 'post',
				url: 'dashboard/users/add',
						headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
					'name': user.name,
					'email': user.email,
					'phone': user.phone ,
					'password': user.password
				}
			});
			return res.data;
		} catch (err) {
			console.log(err);
		}		  
	}
	async addwhatsappAccount(whatsapp_account){
		try {
			console.log(whatsapp_account);
			const res = await axios({
				method: 'post',
				url: 'dashboard/users/whatsapp_account/add',
						headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
					'name': whatsapp_account.name,
					'phone': whatsapp_account.phone ,
					'idInstance': whatsapp_account.idInstance ,
					'page_id': whatsapp_account.page_id ,
					'user_id': whatsapp_account.user_id ,
					'subscription_id': whatsapp_account.subscription_id ,
					'ApiTokenInstance': whatsapp_account.ApiTokenInstance ,
				}
			});

			return {
				status: 'success',
				data : res.data
				
			};
		} catch (err) {
			console.log(err);
			return {
				status: 'error',
				data : err
			};
		}		  
	}
	async addStatus(user_NewStatus){
		try {
			console.log(user_NewStatus);
			const res = await axios({
				method: 'post',
				url: 'dashboard/users/status/add',
						headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
					'comment': user_NewStatus.comment,
					'status_id': user_NewStatus.status_id ,
					'user_id': user_NewStatus.user_id ,
				}
			});

			return {
				status: 'success',
				data : res.data
				
			};
		} catch (err) {
			console.log(err);
			return {
				status: 'error',
				data : err
			};
		}		  
	}
	async EditwhatsappAccount(whatsapp_account){
		try {
			console.log(whatsapp_account);
			const res = await axios({
				method: 'post',
				url: 'dashboard/users/whatsapp_account/edit',
						headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
					'name': whatsapp_account.name,
					'id': whatsapp_account.id,
					'phone': whatsapp_account.phone ,
					'idInstance': whatsapp_account.idInstance ,
					'page_id': whatsapp_account.page_id ,
					'user_id': whatsapp_account.user_id ,
					'subscription_id': whatsapp_account.subscription_id ,
					'ApiTokenInstance': whatsapp_account.ApiTokenInstance ,
				}
			});

			return {
				status: 'success',
				data : res.data
				
			};
		} catch (err) {
			console.log(err);
			return {
				status: 'error',
				data : err
			};
		}		  
	}

	
	async EditSubscriptionsPage(subscriptions_data){
		try {
			console.log(subscriptions_data);
			const res = await axios({
				method: 'post',
				url: 'dashboard/users/subscriptions_data/edit',
						headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
					'page_id': subscriptions_data.page_id ,
					'subscription_id': subscriptions_data.subscription_id ,
					'sub_expire_date': subscriptions_data.sub_expire_date ,
				}
			});

			return {
				status: 'success',
				data : res.data
				
			};
		} catch (err) {
			console.log(err);
			return {
				status: 'error',
				data : err
			};
		}		  
	}

	async EditUser(user){
		try {
			const res = await axios({
				method: 'put',
				url: 'dashboard/users/edit',
						headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
					'id' : user.id ,
					'name': user.name,
					'email': user.email,
					'phone': user.phone ,
					'password': user.password
				}
			});
			return res.data;
		} catch (err) {
			return err;
		}		  
	}
	async RemoveUser(userId){
		try {
			const res = await axios({
				method: 'delete',
				url: 'dashboard/user/'+userId,
						headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
					'user_id' : userId,
				}
			});
			return res;
		} catch (err) {
			return err
		}		  
	}
	async UserPages(userId){
		try {
			const res = await axios({
				method: 'get',
				url: 'dashboard/user/pages?user_id='+userId,
						headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
					'user_id' : userId,
				}
			});
			return res;
		} catch (err) {
			return err
		}		  
	}
	async UserStatuses(userId){
		try {
			const res = await axios({
				method: 'get',
				url: 'dashboard/user/statuses?user_id='+userId,
				headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},
				data: {
					'user_id' : userId,
				}
			});
			return res;
		} catch (err) {
			return err
		}		  
	}

	

	async pageUsers(pageId){
		try {
			const res = await axios({
				method: 'get',
				url: 'dashboard/page/'+pageId+'/users',
				headers: {
					'Authorization' : 'Bearer '+localStorage.getItem('auth-token')
				},

			});
			return res;
		} catch (err) {
			return err
		}		  
	}
}
